"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const body_scroll_lock_1 = require("body-scroll-lock");
const _1 = require(".");
function disableScroll() {
    const modalContent = document.getElementById("spid-lightbox-overlay");
    body_scroll_lock_1.disableBodyScroll(modalContent);
}
exports.disableScroll = disableScroll;
function setOuterAsClosable(focusElement) {
    focusElement.setAttribute("tabIndex", "1");
    focusElement.focus();
    focusElement.onblur = function () {
        _1.ModalManager.close();
    };
}
exports.setOuterAsClosable = setOuterAsClosable;
//# sourceMappingURL=helper.js.map